export default __webpack_public_path__ + "static/media/title_ja_pc@2x.2b3e8389.png";